export const checkinEditDrawer = {
  header: {
    title: "Modifier les informations de check-in",
    age: "Âge :",
    docNotRequiredMinor: "Document non requis (mineur)",
    docOptionalMinorES: "Document facultatif (mineur en Espagne)",
    docOptionalMinorCO: "Document facultatif (moins de 7 ans en Colombie)",
  },
  sections: {
    basicData: "Informations de base",
    stayDates: "Dates du séjour",
    italyDoc: "Document et pays de naissance",
    doc: "Document et nationalité",
  },
  fields: {
    firstName: "Prénom",
    lastName: "Nom",
    email: "E-mail",
    phone: "Téléphone",
    birthDate: "Date de naissance",
    sex: "Sexe",
    checkIn: "Check-in",
    checkOut: "Check-out",
    docType: "Type de document",
    docNumber: "Numéro de document",
    supportNumber: "Numéro de support",
    nationality: "Nationalité",
  },
  placeholders: {
    select: "Sélectionner",
    selectNationality: "Sélectionnez la nationalité",
    searchCountry: "Rechercher un pays...",
    selectCountry: "— sélectionnez un pays —",
    docNumberExample: "ex. AB1234567",
    docNumberGeneric: "DNI / NIE / Passeport",
    required: "Obligatoire",
    optional: "Facultatif",
  },
  sex: {
    male: "Homme",
    female: "Femme",
    preferNotToSay: "Préfère ne pas répondre",
    other: "Autre",
  },
  italy: {
    badge: "Alloggiati Web",
    birthCountryLabel: "Pays de naissance",
    birthCountryHint: "— également utilisé comme nationalité",
    issuePlaceLabel: "Lieu de délivrance du document",
    issuePlaceHint: "— pays où le document a été délivré",
    alloggiatiCode: "Code Alloggiati :",
    iso3Label: "ISO3 :",
    minorNote:
      "Mineur — le type de document, le numéro et le lieu de délivrance sont envoyés vides à Alloggiati Web (TABELLA 1).",
  },
  hints: {
    docOptional:
      "Document facultatif selon la règle d'âge/pays. Vous pouvez tout de même le renseigner.",
  },
  docTypes: {
    it: {
      IDENT: "Document d'identité (IDENT)",
      IDELE: "Document d'identité électronique (IDELE)",
      PASOR: "Passeport ordinaire (PASOR)",
      PASSE: "Passeport de service (PASSE)",
      PASDI: "Passeport diplomatique (PASDI)",
      PATEN: "Permis de conduire (PATEN)",
      PATNA: "Permis bateau (PATNA)",
      CIDIP: "Carte d'identité diplomatique (CIDIP)",
      RIFUG: "Titre de voyage pour réfugié (RIFUG)",
    },
    co: {
      CC: "Carte de citoyenneté",
      CE: "Carte d'identité d'étranger",
      P: "Passeport",
      PPT: "Permis de protection temporaire",
      PEP: "Permis de séjour spécial",
      DE: "Document étranger",
      CD: "Carte diplomatique",
    },
    es: {
      ID: "DNI",
      IM: "NIE",
      P: "Passeport",
      OTRO: "Autre",
    },
    generic: {
      ID: "Document d'identité",
      P: "Passeport",
      OTRO: "Autre",
    },
  },
  footer: {
    cancel: "Annuler",
    save: "Enregistrer",
    saving: "Enregistrement...",
  },
  errors: {
    nameRequired: "Le prénom et le nom sont obligatoires.",
    emailInvalid: "E-mail invalide.",
    phoneRequired: "Le téléphone est obligatoire.",
    birthDateRequired: "La date de naissance est obligatoire.",
    sexRequired: "Le sexe est obligatoire.",
    stayDatesRequired: "Les dates du séjour sont obligatoires.",
    checkoutBeforeCheckin: "La date de check-out ne peut pas être antérieure à la date de check-in.",
    birthCountryRequired: "Le pays de naissance est obligatoire.",
    docTypeRequired: "Le type de document est obligatoire.",
    docNumberRequired: "Le numéro de document est obligatoire.",
    issuePlaceRequired: "Le lieu de délivrance du document est obligatoire.",
    nationalityRequired: "La nationalité est obligatoire.",
    supportNumberRequired:
      "Le numéro de support est obligatoire pour la nationalité espagnole (adulte).",
    saveFailed: "Impossible d'enregistrer.",
    saveError: "Erreur lors de l'enregistrement des modifications.",
  },
  toast: {
    saved: "Check-in mis à jour avec succès",
  },
};
